const Logo = () => (
  <picture>
    <source
      media="(min-width: 1025px)"
      type="image/webp"
      srcSet="logos/golden-edge.webp"
    />
    <source
      media="(min-width: 1025px)"
      srcSet="logos/golden-edge.jpg"
    />

    <source
      media="(min-width: 481px)"
      type="image/webp"
      srcSet="logos/golden-edge-824.webp"
    />
    <source
      media="(min-width: 481px)"
      srcSet="logos/golden-edge-824.jpg"
    />

    <source
      media="(max-width: 480px)"
      type="image/webp"
      srcSet="logos/golden-edge-412.webp"
    />
    <img
      className="hero-image"
      src="logos/golden-edge-412.jpg"
      alt="Golden Edge Logo"
      width={700}
      height={700}
      fetchPriority="high"
      decoding="async"
      loading="eager"
    />
  </picture>
);

export default Logo;


